import Axios from "axios";
import { TokenService } from "./storageService";

let options = {
    baseURL: `${process.env.API_URL}${process.env.API_PATH}`,
    headers: {
        'content-type': process.env.API_TYPE,
        'token': null
    }
};
const ApiService = {

	setCountry() {
		if (process.env.API_COUNTRY == 'true') {
			let country = TokenService.getItem('COUNTRY', false) || ''
			options.baseURL = `${process.env.API_URL}${process.env.API_PATH}${country.toLowerCase()}`
		}
	},

    setHeader(type, value) {
        options.headers[type] = value;
    },

    get(resource) {
		this.setCountry()
        return Axios.get(resource, options);
    },

    post(resource, data) {
		this.setCountry()
        return Axios.post(resource, data, options);
    },

    put(resource, data) {
		this.setCountry()
        return Axios.put(resource, data, options);
    },

    delete(resource) {
		this.setCountry()
        return Axios.delete(resource, options);
    },

    customRequest(data) {
        return Axios(data)
    },

    siafiLogin() {
        return Axios.post('Users/Login', {
            userName: process.env.SIAFI_USER,
            password: process.env.SIAFI_PASS
        }, {
            baseURL: `${process.env.SIAFI_URL}${process.env.SIAFI_PATH}`,
            withCredentials: true,
            headers: {
                "Content-Type": process.env.SIAFI_TYPE,
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
                "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
            }
        });
    },

    siafiGet(url, token) {
        return Axios.get(url, {
            baseURL: `${process.env.SIAFI_URL}${process.env.SIAFI_PATH}`,
            withCredentials: true,
            headers: {
                "Authorization": `bearer ${token}`,
                // "Content-Type": process.env.SIAFI_TYPE,
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
                "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
            }
        });
    },

    siafiPost(url, data, token) {
        return Axios.post(url, data ,{
            baseURL: `${process.env.SIAFI_URL}${process.env.SIAFI_PATH}`,
            withCredentials: true,
            headers: {
                "Authorization": `bearer ${token}`,
                // "Content-Type": process.env.SIAFI_TYPE,
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
                "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
            }
        });
    },

    camGet(url,token){
        return Axios.get(url,{
            baseUrl: `${process.env.API_CAM_URL}${process.env.API_CAM_PATH}`,
            headers:{
                'content-type': process.env.API_CAM_TYPE,
                'token':token
            }
        })
    },

    camPost(url,data,token){
        return Axios.post(url,data,{
            baseURL: `${process.env.API_CAM_URL}${process.env.API_CAM_PATH}`,
            headers:{
                'content-type': process.env.API_CAM_TYPE,
                'token':token
            }
        })
    }
}

export default ApiService;
